(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SampleAttach', SampleAttach);

    SampleAttach.$inject = ['$resource'];

    function SampleAttach ($resource) {
        var resourceUrl =  'api/samples/:id/attachments';

        return $resource(resourceUrl, {ids: '@ids'}, {
            'query': { method: 'GET', isArray: true},
            'getPublic': { url: 'api/public/:hash/attachments', method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            getReports: {
            	url: 'api/samples/report/:id',
            	method: 'GET',
            	isArray: true
            },
            getBulkPictures: {
            	url: 'api/samples/pictures',
            	method: 'GET',
            	isArray:false,
            	params: {ids: '@ids'}
            }
        });
    }
})();
